import {
  Box,
  Flex,
  Text,
  Textarea,
  chakra,
  Button,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import { CrossSvg } from "@root/assets/icons";

export const StyledHeaderContainer = chakra(Box, {
  baseStyle: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: "theme.gray.200",
    padding: "15px",
    gap: "12px",
    zIndex: 0,
  },
});

export const StyledContainer = chakra(Flex, {
  baseStyle: {
    bg: "theme.bg.box", // Use either bg or backgroundColor, not both
    borderRadius: "16px",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    gap: "10px",
    width: "100%",
  },
});
export const StyledTextareaContainer = chakra(Textarea, {
  baseStyle: {
    width: "100%",
    border: "none",
    outline: "none",
    position: "relative",
    zIndex: 2,
    color: "gray.neutral",
    backgroundColor: "transparent",
    resize: "none",
    overflow: "scroll",
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "1.5",
    _focus: {
      border: "none",
      outline: "none",
      boxShadow: "none",
    },
    _placeholder: {
      color: "gray.lightGray500",
    },
  },
});

export const StyledChatContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column",
    height: "100%",
    // overflowY: "auto",
    paddingBottom: "60px",
    boxSizing: "border-box",
    position: "relative",
  },
});

export const StyledPlaceholder = chakra(Text, {
  baseStyle: {
    width: "10px",
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "gray.500",
    fontSize: "16px",
    pl: "16px",
    userSelect: "none",
    zIndex: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

export const StyledPrimaryMention = chakra(Flex, {
  baseStyle: {
    display: "inline",
    borderRadius: "4px",
    color: "theme.button.primary",
    bgColor: "theme.alert.200",
    mx: "6px",
    p: "4px 6px",
  },
});

export const StyledSendContainer = chakra(Flex, {
  baseStyle: {
    height: "52px",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const StayledInputContainer = chakra(Box, {
  baseStyle: {
    borderRadius: "16px",
    position: "relative",
    // width: { base: "96%", md: "80%", lg: "90%", halfxl: "1260px" },
    // mx: "auto",
    py: "10px",
  },
});

// Commented for Future use
// export const StayledInputContainer = chakra(Box, {
//   shouldForwardProp: (prop) => ["isAtBottom"].includes(prop) || typeof prop === 'string',
//   baseStyle: (props: StayledInputContainerProps & { theme: any }): CSSObject => ({
//     background: "theme.brown.100",
//     borderRadius: "16px",
//     position: "absolute",
//     width: { base: "96%", md: "80%", lg: "90%", halfxl: "1260px" },
//     mx: "auto",
//     my: "24px",
//     zIndex: 10,
//     ...(props.isAtBottom
//       ? { bottom: "16px", top: "auto", transform: "none" }
//       : { top: "50%", left: "50%", transform: "translate(-50%, -50%)" }),
//   }),
// }) as typeof Box;

export const StyledFileTag = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    height: "32px",
    width: "fit-content",
    bgColor: "theme.gray.50",
    px: "8px",
    borderRadius: "4px",
  },
});
export const StyledCrossSvg = chakra(CrossSvg, {
  baseStyle: {
    cursor: "pointer",
    width: "16px",
    height: "16px",
    position: "absolute",
    top: -1.5,
    right: -1.5,
  },
});

// --- ADDED BELOW ---

export const AttachmentButton = chakra(Button, {
  baseStyle: {
    border: "1.5px solid #7A97B8",
    borderRadius: "24px",
    fontWeight: 500,
    position: "absolute",
    bottom: "10px",
    left: "20px",
    zIndex: 20,
    color: "#4666A5",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: "16px",
    width: "fit-content",
    height: "32px",
    fontSize: "14px",
    _hover: {
      bg: "#EFF7FF",
      borderColor: "#4666A5",
    },
    _active: {
      bg: "#E6F0FF",
      borderColor: "#4666A5",
    },
    transition: "all 0.2s",
    boxShadow: "none",
  },
});

export const AttachmentFileBox = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
    bg: "#E8F0F8",
    borderRadius: "5px",
    px: "16px",
    py: "8px",
    width: "220px",
    height: "32px",
    top: "5px",
    left: "20px",
    zIndex: 20,
    boxShadow: "sm",
  },
});

export const AttachmentFileText = chakra(Text, {
  baseStyle: {
    color: "#4666A5",
    fontWeight: 500,
    fontSize: "17px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "160px",
  },
});

export const AttachmentFileSpinner = chakra(Box, {
  baseStyle: {
    ml: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "18px",
    minHeight: "18px",
  },
});

export const AttachmentCloseBtn = chakra(Box, {
  baseStyle: {
    ml: "10px",
    cursor: "pointer",
    color: "#4666A5",
    fontWeight: "bold",
    fontSize: "22px",
    lineHeight: "1",
    _hover: {
      color: "#2442A9",
    },
    minWidth: "20px",
    textAlign: "center",
  },
});
export const DeleteIconContainer = chakra(Box, {
  baseStyle: {
    zIndex: 1,
  },
});

export const LabelContainer = chakra(Box, {
  baseStyle: {
    border: "1px",
    borderRadius: "6px",
    w: "5",
    h: "5",
    p: "3",
    fontSize: "xs",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
export const DocumentStack = chakra(HStack, {
  baseStyle: {},
});

export const CardListContainer = chakra(Box, {
  baseStyle: {
    maxH: "500px",
    width: "1145px",
    overflowY: "auto",
    padding: "2",
    borderRadius: "16",
    borderLeft: "4px solid #40599B",
  },
});
export const ExportChecklistButton = chakra(Button, {
  baseStyle: {
    height: "fit-content",
    py: "2",
    colorScheme: "blue",
    variant: "outline",
    borderRadius: "50px",
  },
});

export const InputBox = chakra(Box, {
  baseStyle: {
    border: "1.3px dashed #A7B2BA",
    borderWidth: "1px",
    borderRadius: "18px",
    bg: "#F8FAFF",
    p: "8",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
  },
});
export const UploadIconButton = chakra(IconButton, {
  baseStyle: {
    mb: 4,
    width: "48px",
    height: "48px",
    bg: "transparent",
    color: "#337CC1",
    _hover: {
      bg: "#EAF1FF",
    },
  },
});
